export const dashboardTranslation = {
  dashboard_not_render_description: 7477,

  favourite_unsupported_presentation_type: 7478,
  favourite_no_layout_model: 7479,
  favourite_not_render: 7482,
  favourite_not_present_type_favourite: 7483,

  chart_not_supported_type: 7484,

  no_search_result: 6778,

  filters_title: 7556,
  print: 8353,

  manage_dashboards_option: 9339,
  edit_dashboard: 8723,
  edit_saved_reports: 8724,

  save_new_dashboard: 9015,
  refresh_dashboard: 9558,
  update_existing_dashboard: 9017,
  bowtie_multiple_instance_warning_message: 9373,
  open_saved_report: 9845
};

export const dashboardLayoutTypeContext = 2;
